import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { careersActions } from '../../../redux/actions';

const useCareer = () => {
    const dispatch = useDispatch();
    const allCareers = useSelector((state) => state.careers.careers);

    const [career, setCareer] = useState(null);
    const [products, setProducts] = useState(null);
    const [currentCareers, setCurrentCareers] = useState(null);
    const [search, setSearch] = useState('');
    const [filteredCareers, setFilteredCareers] = useState(null);

    useEffect(() => {
        allCareers === null && dispatch(careersActions.getCareersRequest());
        if (!products && allCareers) {
            getCareerProduct();
        }
    }, [allCareers, products]);

    // Configuración del orden de tabs (fácil de mantener)
    const TAB_ORDER = ['Diplomados', 'Especialización Online', 'Workshops', 'Major', 'Maestría', 'Doctorado', 'Certificaciones'];
    // Configuración de tabs a excluir
    const TAB_EXCLUDE = [''];

    // Reordena las tabs según configuración
    const reorderTabs = (tabs) => {
        // Separar tabs prioritarias
        const priorityTabs = TAB_ORDER.map(label => 
            tabs.find(tab => tab.label === label)
        ).filter(Boolean);

        // Obtener tabs restantes (excluyendo las prioritarias y las excluidas)
        const otherTabs = tabs.filter(tab => 
            !TAB_ORDER.includes(tab.label) && 
            !TAB_EXCLUDE.includes(tab.label)
        );

        // Reasignar IDs secuenciales
        return [...priorityTabs, ...otherTabs].map((tab, index) => ({
            ...tab,
            id: index
        }));
    };

    const reorderProducts = (orderedTabs, originalProducts) => {
        return orderedTabs.map(tab => {
            // Buscar el producto original que coincida con el label de la tab
            return originalProducts.find(product => product.category_name === tab.label);
        });
    };

    // ORDENAMOS Y SETEAMOS LOS DATOS DEL ENDPOINT A RENDERIZAR
    const getCareerProduct = async () => {
        const data = allCareers.map((item, i) => ({
            label: item.category_name,
            id: i,
            disabled: false,
            data: item.category_products,
        }));

        handleDisabled(data);

        const orderedData = reorderTabs(data);
        const orderedProducts = reorderProducts(orderedData, allCareers);
        
        setProducts(orderedProducts);
        setCareer(orderedData);
        handleProduct(handleViewTab(orderedData), orderedProducts);
    };

    // SETEA EL CONTEIDO A RENDERIZAR
    const handleProduct = (idTab, request) => {
        if (products) {
            setCurrentCareers(products[idTab]?.category_products);
        } else {
            setCurrentCareers(request[idTab]?.category_products);
        }
        setSearch('');
        setFilteredCareers(null);
    };

    const handleProductByLabel = (label) => {
        if (products) {
            const foundIndex = products.findIndex(
                (product) => product.category_name === label
            );
            if (foundIndex !== -1) {
                setCurrentCareers(products[foundIndex]?.category_products);
            } else {
                setCurrentCareers(null);
            }
        }
        setSearch('');
        setFilteredCareers(null);
        const foundIndex = TAB_ORDER.indexOf(label);
        return foundIndex !== -1 ? foundIndex : 0;
    }

    // // TRAE EL ID DEL PRIMER OBJETO QUE NO TRAIGA UN ARRAY VACÍO
    // TRAE EL CONTENIDO DEL TAB DIPLOMADO (TEMPORAL)
    const handleViewTab = (data) => {
        // const tabView = data.find(item => item.data.length !== 0)
        const tabView = data.find((item) => item.label === 'Diplomados');
        return tabView.id;
    };

    // DESHABILITA TABS QUE NO TRAIGAN CONTENIDO
    const handleDisabled = (data) => {
        data.forEach((item) => {
            if (item.data.length === 0) {
                item.disabled = true;
            }
        });
    };

    const handleChange = (e) => {
        setSearch(e.target.value);
        filterCareers(e.target.value);
    };

    // FILTRA POR INPUT DE TEXTO
    const filterCareers = (input) => {
        const filteredCareers = currentCareers.filter((career) =>
            career.name.toLowerCase().includes(input.toLowerCase())
        );
        setFilteredCareers(filteredCareers);
    };

    return {
        career,
        search,
        products,
        handleProduct,
        handleProductByLabel,
        currentCareers,
        handleChange,
        filteredCareers,
    };
};

export default useCareer;
